<template>
  <modal :name="name" height="auto" :scrollable="true" @before-open="beforeOpen" @before-close="beforeClose">
    <form @submit.prevent>
      <div class="py-4 text-left px-6 ">
        <!-- title and close button -->
        <div class="flex justify-between items-center pb-3">
          <p class="flex-2 text-2xl font-bold">{{ title }}</p>
          <close-icon class="flex" @click="() => $modal.hide(name)"></close-icon>
        </div>

        <!-- main content -->
        <slot></slot>
      </div>
    </form>
  </modal>
</template>

<script>
import CloseIcon from './CloseIcon.vue'

export default {
  components: {
    CloseIcon
  },
  props: {
    name: {
      type: String,
      default: 'window'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      status: '',
      loading: false
    }
  },
  methods: {
    beforeOpen() {},
    beforeClose() {}
  }
}
</script>

<style></style>
